import { render } from "./ChartLastValue.vue?vue&type=template&id=4a87ffa3&scoped=true"
import script from "./ChartLastValue.vue?vue&type=script&setup=true&lang=js"
export * from "./ChartLastValue.vue?vue&type=script&setup=true&lang=js"

import "./ChartLastValue.vue?vue&type=style&index=0&id=4a87ffa3&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a87ffa3"],['__file',"src/containers/components/chart/ChartLastValue.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4a87ffa3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4a87ffa3', __exports__)) {
    api.reload('4a87ffa3', __exports__)
  }
  
  module.hot.accept("./ChartLastValue.vue?vue&type=template&id=4a87ffa3&scoped=true", () => {
    api.rerender('4a87ffa3', render)
  })

}


export default __exports__